import { render, staticRenderFns } from "./ScannedProductsPerSellerIndicator.vue?vue&type=template&id=1e32048e"
import script from "./ScannedProductsPerSellerIndicator.vue?vue&type=script&lang=js"
export * from "./ScannedProductsPerSellerIndicator.vue?vue&type=script&lang=js"
import style0 from "./ScannedProductsPerSellerIndicator.vue?vue&type=style&index=0&id=1e32048e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports